import React, { useEffect, useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import { Typography, Checkbox, colors, Button } from '@leapeasy/ui-kit';
import {
  CANCELLATION_DISCLAIMER_TEXT,
  CLAIM_TRUTH_ACK_TEXT,
  SUBROGATION_ACK_TEXT,
} from 'utils/cancellationDisclaimer';

export default function ConfirmDialog(props) {
  const { open, handleClose, handleOk, showCancellationDisclaimer = false } = props;
  const [confirmCheck1, setConfirmCheck1] = useState(false);
  const [confirmCheck2, setConfirmCheck2] = useState(false);
  const [cancellationDisclaimerAcknowledged, setCancellationDisclaimerAcknowledged] =
    useState(false);

  useEffect(() => {
    if (open) {
      setConfirmCheck1(false);
      setConfirmCheck2(false);
      setCancellationDisclaimerAcknowledged(false);
    }
  }, [open]);

  const canSubmit =
    confirmCheck1 &&
    confirmCheck2 &&
    (!showCancellationDisclaimer || cancellationDisclaimerAcknowledged);

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: '24px 20px' }}>
          <DialogContentText>
            {showCancellationDisclaimer && (
              <Box display="flex" alignItems="flex-start" gap="12px" mb={2}>
                <Box mt={0.5}>
                  <Checkbox
                    checked={cancellationDisclaimerAcknowledged}
                    onChange={(value) => setCancellationDisclaimerAcknowledged(value)}
                  />
                </Box>
                <Typography variant="body1" style={{ color: colors.purple[900] }}>
                  {CANCELLATION_DISCLAIMER_TEXT}
                </Typography>
              </Box>
            )}
            <Box display="flex" alignItems="flex-start" gap="12px" mb={2}>
              <Box mt={0.5}>
                <Checkbox checked={confirmCheck1} onChange={(value) => setConfirmCheck1(value)} />
              </Box>

              <Typography variant="body1" style={{ color: colors.purple[900] }}>
                {CLAIM_TRUTH_ACK_TEXT}
              </Typography>
            </Box>

            <Box display="flex" alignItems="flex-start" gap="12px">
              <Box mt={0.5}>
                <Checkbox checked={confirmCheck2} onChange={(value) => setConfirmCheck2(value)} />
              </Box>

              <Typography variant="body1" style={{ color: colors.purple[900] }}>
                {SUBROGATION_ACK_TEXT}
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ padding: '24px 20px', paddingTop: 0 }}>
          <Box display="flex" gap="12px" sx={{ padding: '0px 24px', width: '100%' }}>
            <Button size="medium" variant="secondary" onClick={handleClose}>
              <Typography color="secondary">Cancel</Typography>
            </Button>

            <Button size="medium" variant="primary" onClick={handleOk} disabled={!canSubmit}>
              <Typography color="Primary">Submit</Typography>
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
